const VERSION_URL = "/version.js";

export function getVersionFingerprint(info) {
  if (!info) return "";
  return [info.version, info.gitBuildVersion, info.buildTime, info.gitCommit].join("|");
}

function parseVersionModule(source) {
  const match = source.match(/var appVersion\s*=\s*(\{[\s\S]*?\});/);
  if (!match) {
    throw new Error("Invalid version.js payload");
  }
  return JSON.parse(match[1]);
}

export async function fetchAppVersion() {
  const response = await fetch(`${VERSION_URL}?_=${Date.now()}`, {
    cache: "no-store",
    headers: { "Cache-Control": "no-cache" },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch ${VERSION_URL}: ${response.status}`);
  }

  const text = await response.text();
  const info = parseVersionModule(text);

  if (!info.buildTime && !info.version) {
    throw new Error("Invalid version.js payload");
  }

  return info;
}
